import 'tinymce/tinymce';

import 'tinymce/icons/default';
import 'tinymce/themes/silver';

import 'tinymce/plugins/lists';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/image';
import 'tinymce/plugins/link';
import 'tinymce/plugins/table';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/codesample';
import 'tinymce/plugins/code';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/help';

import 'tinymce/skins/ui/oxide/skin.min.css';

export default {
	content_css: false,
	menubar: false,
	height: 750,
	skin: false,
	plugins: [
		'lists', 'advlist', 'image', 'link', 'table', 'charmap', 'codesample', 'code', 'preview', 'fullscreen', 'help'
	],
	toolbar_mode: 'wrap',
	toolbar: `
		undo redo | bold italic underline strikethrough | formatselect fontsizeselect |
		alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist |
		forecolor backcolor removeformat | image link table | charmap codesample |
		code preview fullscreen | help
	`,
	block_formats: 'Paragraph=p;Header 6=h6;Header 5=h5;Header 4=h4',
	formats: {
		p: { block: 'p', styles: { fontSize: '1em' } },
		h6: { block: 'h6', styles: { fontSize: '1em' } },
		h5: { block: 'h5', styles: { fontSize: '1.2em', lineHeight: '1.5' } },
		h4: { block: 'h4', styles: { fontSize: '1.5em', lineHeight: '1.5' } }
	},
	font_formats: 'Suisse Intl',
	fontsize_formats: '1em 1.1em 1.2em 1.3em 1.4em 1.5em',
	content_style: `
		body {
			font-family: "Suisse Intl";
			margin: 0;
			font-weight: 400;
			font-size: 15px;
			color: #ffffff;
			line-height: calc(26 / 15);
			background: #23395e;
		}
		body * {
			margin: 0;
		}
		table {
			border-color: #ffffff;
		}
		table td {
			padding: 0 5px;
		}
		img {
			border-radius: 15px;
		}
		a {
			color: inherit;
			text-decoration: underline;
		}
	`
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/article/editor/editor-field/configuration.js